const INTEREST_STEP = 5; // +$1 interest per $5 saved
const INTEREST_CAP = 3; // Maximum +$3 interest per round

export function calculateIncome(currentMoney) {
  const money = currentMoney || 0;
  return Math.min(INTEREST_CAP, Math.floor(money / INTEREST_STEP));
}

export function applyRoundBudgetUpdate(currentMoney, result, rewards = { win: 0, draw: 0, loss: 0 }) {
  const income = calculateIncome(currentMoney);
  const afterIncome = currentMoney + income;
  let delta = 0;
  if (result === 'win') delta = rewards.win || 0;
  else if (result === 'draw') delta = rewards.draw || 0;
  else if (result === 'loss') delta = rewards.loss || 0;
  return { money: afterIncome + delta, income, rewardDelta: delta };
}

/**
 * Calculate the opponent's cumulative budget for a given round
 * Budget increases by $2/round base, plus +$1 every 5 rounds
 * 
 * @param {number} roundNumber - The current round (1-indexed)
 * @returns {number} The total budget available to the opponent
 */
export function getOpponentBudget(roundNumber) {
  const round = Math.max(1, roundNumber || 1);
  let total = 0;
  for (let r = 1; r <= round; r++) {
    const incomePerRound = 2 + Math.floor((r - 1) / 5); // +$1 every 5 rounds (1-5 => $2, 6-10 => $3, etc.)
    total += incomePerRound;
  }
  return total;
}
